import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../hooks/useRedux"; // Adjust path to your Redux hooks
import { BASE_URL } from "../Constants/BaseUrl"; // Adjust path to your constants

const UserListItem = ({ color, item, sport_name }) => {
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.user);

  // Safely get details based on role
  const details =
    item.role === "coach"
      ? item.coach_details
      : item.role === "student-athlete"
        ? item.athlete_details
        : null;

  if (!details) return null;

  return (
    <div
      className="flex items-center px-5 py-2.5 border-b border-[#333333] border-opacity-50 relative"
      onClick={() => {
        if (Number(item.user_id) !== Number(user?.user_id)) {
          if (item.role === "coach") {
            navigate("/coach-public-profile", {
              state: {
                user_id: item?.user_id,
              },
            });
          } else {
            navigate("/public-profile", {
              state: {
                user_id: item?.user_id,
              },
            });
          }
        } else {
          navigate("/profile-coach", {
            state: {
              user_id: item?.user_id,
            },
          });
        }
      }}
    >
      <img
        // src={
        //   item?.profile_picture
        //     ? `${BASE_URL}/${item.profile_picture}`
        //     : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU"
        // }
        src={
          item?.profile_picture?.startsWith("https")
            ? item?.profile_picture
            : item?.profile_picture
              ? `${BASE_URL}/${item.profile_picture}`
              : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU"
        }
        alt="User avatar"
        className="w-[60px] h-[60px] rounded-full border-2 border-[#C00000] mr-[15px] object-cover"
      />
      <div className="flex-1 flex flex-col justify-center">
        <p className="text-[18px] font-semibold font-roboto text-white">
          {details?.first_name ?? ""} {details?.last_name ?? ""}
        </p>
        <p className="text-[14px] font-normal font-roboto mt-1 truncate text-white">
          Sport: {sport_name}
        </p>
      </div>
    </div>
  );
};

export default UserListItem;
